// extracted by mini-css-extract-plugin
export default {"container":"hint_container__dx4vG","text":"hint_text__GHBlZ"};